import React from 'react'

import { getConstantByLocale, getLocaleFromSession } from 'utils/locale'

import DialogcardTurnArrow from '../DialogcardTurnArrow'

import { TURN } from './constants'
import { ArrowContainer, TurnIndicatorContainer } from './style'

const DialogcardTurnIndicator = () => {
  const currentLocale = getLocaleFromSession()
  const text = getConstantByLocale(TURN, currentLocale)
  return (
    <TurnIndicatorContainer>
      {text}
      <ArrowContainer>
        <DialogcardTurnArrow />
      </ArrowContainer>
    </TurnIndicatorContainer>
  )
}

export default DialogcardTurnIndicator
